import React, { FC } from "react";
import styles from "./SpotlightrGalleryVideoSection.module.css";
import {
	IUserTrainingCourseSectionSummary,
	IUserTrainingCourseVideoSummary,
} from "src/@types/ImpiricaPlatformApi";
import { SpotlightrGalleryVideoThumbnail } from "./SpotlightrVideoThumbnail";

type SpotlightrGalleryVideoSectionProps = {
	section: IUserTrainingCourseSectionSummary;
	onLaunchVideo?: (video: IUserTrainingCourseVideoSummary) => void;
};

export const SpotlightrGalleryVideoSection: FC<
	SpotlightrGalleryVideoSectionProps
> = ({ section, onLaunchVideo }) => {
	return (
		<div data-testid="video-section">
			{section.name && <h3>{section.name}</h3>}
			<hr />
			<div className={styles.videoSectionVideos}>
				{section.videos &&
					section.videos.map((video) => (
						<SpotlightrGalleryVideoThumbnail
							video={video}
							key={video.id}
							onLaunchVideo={onLaunchVideo}
						/>
					))}
			</div>
		</div>
	);
};
